import React from "react";
import style from "./Header.module.css";
import { Icon } from "@iconify/react";
import ketum from "./svg_ketum.svg";
const Header = () => {
  return (
    <div className={`${"header"} ${style.header}`}>
      {/* <div className="container-fluid" style={{ backgroundColor: "red" }}> */}
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-7">
            <div className={style.description}>
              <div className={style.text}>
                <h1 className={style.title}>PIMPINAN DAERAH</h1>
                <h2 className={style.subtitle}>IKATAN PELAJAR MUHAMMADIYAH</h2>
                <h3 className={style.subsubtitle}>KABUPATEN KARAWANG</h3>
              </div>

              <div className={style.social_media}>
                <a
                  href="https://www.facebook.com/profile.php?id=100075071433539"
                  target="_blank"
                >
                  <Icon
                    className={`${style.icon} ${style.icon_facebook}`}
                    icon="brandico:facebook-rect"
                  />
                </a>
                <a
                  href="https://www.instagram.com/pdipmkarawang/"
                  target="_blank"
                >
                  <Icon
                    className={style.icon}
                    icon="ant-design:instagram-filled"
                  />
                </a>

                <a href="mailto:pdipmkarawang@gmail.com" target="_blank">
                  <Icon className={style.icon} icon="mdi:gmail" />
                </a>
              </div>
            </div>
          </div>
          <div className={`col-md-5 ${style.image_container}`}>
            <img src={ketum} className={`img-fluid ${style.image}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
